import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index() {
    return api.get("/api/v1/ticket-reminder", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  create(data) {
    return api.post("/api/v1/ticket-reminder", data, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  delete(id) {
    return api.delete(`/api/v1/ticket-reminder/${id}`);
  },
};
